export const ASSET_ROOT_UPLOAD_GET_DATA = 'ASSET_ROOT_UPLOAD_GET_DATA'
export const ASSET_ROOT_UPLOAD_GET_DATA_SUCCESS = 'ASSET_ROOT_UPLOAD_GET_DATA_SUCCESS'
export const ASSET_ROOT_UPLOAD_GET_DATA_FAILURE = 'ASSET_ROOT_UPLOAD_GET_DATA_FAILURE'